import React from "react";
import logo from "src/images/logo.png";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { PrimaryButton as PrimaryButtonBase } from "src/components/misc/Buttons.js";

const PrimaryButton = styled(PrimaryButtonBase)(props => [
    tw`mt-12 text-sm inline-block mx-auto md:mx-0`,
    props.buttonRounded && tw`rounded-full`
  ]);
const MaintenancePage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-center p-6">
      <div className="max-w-md p-8 bg-white shadow-lg rounded-2xl">
        <img 
          src={logo} 
          alt="Maintenance" 
          className="w-40 h-40 mx-auto"
          height={260}
          width={260}
        />
        <h1 className="text-2xl font-bold text-gray-800 mt-4">We’ll be back soon!</h1>
        <p className="text-gray-600 mt-2">
          This page is currently undergoing maintenance. We’ll be back online shortly.
        </p>
        <PrimaryButton buttonRounded={true} as="a" href="/">
              Go back
            </PrimaryButton>
        {/* <button 
          onClick={() => window.location.reload()} 
          className="mt-4 px-6 py-2 bg-blue-600 text-white rounded-lg shadow-md hover:bg-blue-700 transition"
        >
          Refresh Page
        </button> */}
      </div>
    </div>
  );
};

export default MaintenancePage;
